import { useContext } from "react";
import DropdownLanguageContext from "../contexts/DropdownLanguageContext";

const useDropDownLanguageHook = () => useContext(DropdownLanguageContext);

export default useDropDownLanguageHook;
